export default "/images/branding-nlinker.png?531fb37eb2e8dc959975df5aaf505a89";